import svg4everybody from 'svg4everybody';
// import * as CookieConsent from "vanilla-cookieconsent";
import CookieConsentConfig from "./utils/cookieconsent-config";
import { textAnimations } from './utils/text-animations';
import { initMediasEvents } from './utils/medias';
import { $html } from './utils/dom';
import { ENV } from './config';

// Dynamic imports for development mode only
let gridHelper;
let CookieConsent;

(async () => {
    if (ENV.IS_DEV) {
        const gridHelperModule = await import('./utils/grid-helper');
        gridHelper = gridHelperModule?.gridHelper;
    }
})();

(async () => {
    CookieConsent = await import('vanilla-cookieconsent');
    CookieConsentConfig.language.default = $html.getAttribute('lang').split('-')[0];
    CookieConsent.run(CookieConsentConfig);
    $html.classList.add('cc--darkmode');
})();

export default function () {
    // -------------------------------------
    // Use external SVG spritemaps
    // -------------------------------------
    svg4everybody();
    
    // -------------------------------------
    // Grid helper
    // -------------------------------------
    gridHelper?.();
}
